module.exports = __webpack_public_path__ + "static/media/mainBottom@3x.8a8cb1e1.png";